import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getVisiblePostcodes, setFeatureRootState } from "../utils/map";

import { lookupTableSelector } from "../reducers/depot/selectors";
import { jumpToSelector, zoomLevelSelector } from "../reducers/map/selectors";
import {
  resetJumpTo,
  setCenterPoint,
  setVisiblePostcodes,
} from "../reducers/map";
import {
  adjustToTargetZoomLevel,
  calculateZoomLevel,
  setReceivedUserInput,
} from "../reducers/map/thunkActions";

export const useDepotMap = () => {
  const [map, setMap] = useState();
  const [changed, setChanged] = useState(false);
  const dispatch = useDispatch();
  const lookupTables = useSelector(lookupTableSelector);
  const jumpTo = useSelector(jumpToSelector);
  const zoomLevel = useSelector(zoomLevelSelector);

  useEffect(() => {
    if (!map) return;
    else if (jumpTo) {
      map.flyTo({ ...jumpTo, duration: 2000 });
      dispatch(resetJumpTo());
      return;
    } else if (!changed) return;

    const result = getVisiblePostcodes(map, zoomLevel);
    dispatch(setVisiblePostcodes(result));
    const { lng, lat } = map.getCenter();
    dispatch(setCenterPoint([lng, lat]));
    dispatch(calculateZoomLevel());
    dispatch(adjustToTargetZoomLevel(map));
    setChanged(false);
  }, [changed, dispatch, map, zoomLevel, jumpTo]);

  useEffect(() => {
    if (!map || !lookupTables) return;
    setFeatureRootState({ map, lookupTables });
    setChanged(true);
  }, [dispatch, map, lookupTables]);

  const handleOnLoad = (m) => {
    setMap(m);
    m.on("wheel", () => dispatch(setReceivedUserInput(true)));
    m.on("idle", () => setChanged(true));
  };

  return { map, handleOnLoad };
};
